import { render, staticRenderFns } from "./VehicleInspection.vue?vue&type=template&id=be4e2662&scoped=true"
import script from "./VehicleInspection.vue?vue&type=script&lang=js"
export * from "./VehicleInspection.vue?vue&type=script&lang=js"
import style0 from "./VehicleInspection.vue?vue&type=style&index=0&id=be4e2662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4e2662",
  null
  
)

export default component.exports